export class RdsPasswordConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "passwordManagementType",
            "baseName": "passwordManagementType",
            "type": "RdsPasswordConfigPasswordManagementTypeEnum",
            "format": ""
        },
        {
            "name": "password",
            "baseName": "password",
            "type": "string",
            "format": ""
        },
        {
            "name": "secretsManagerKmsKeyId",
            "baseName": "secretsManagerKmsKeyId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RdsPasswordConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var RdsPasswordConfigPasswordManagementTypeEnum;
(function (RdsPasswordConfigPasswordManagementTypeEnum) {
    RdsPasswordConfigPasswordManagementTypeEnum["AwsSecretsManager"] = "AWS_SECRETS_MANAGER";
    RdsPasswordConfigPasswordManagementTypeEnum["SelfManaged"] = "SELF_MANAGED";
})(RdsPasswordConfigPasswordManagementTypeEnum || (RdsPasswordConfigPasswordManagementTypeEnum = {}));
